import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import Pagination from './../../../../shared/components/pagination';
import Report from '../../../services/report.service';
import Util from '../../../../shared/util/util'
import Loader from './../../../../shared/components/loader'
import XLSX from 'xlsx';
import Multiselect from 'vue-multiselect'
import TripServices from './../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import DatePicker from 'vue2-datepicker';
export default {
  name: 'pincodelog',
  components: {
    Pagination,
    VueElementLoading,
    Loader,
	  Multiselect,
	  DatePicker
  },
  props: [],
  data() {
    return {
      isLoading:false,
      offset:0,
      pageLimit:10,
      idx:1,
      FromDateErr:'',
      ToDateErr:'',
      MainErr:'',
      startdate:'',
      enddate:'',
      todaysDate: '',
      validDateRange: '',
      validDateRangeFrom: '',
      todaysDate1: '',
      validDateRange1: '',
      validDateRangeFrom1: '',
      selectedStartDate:'',
      PrintStickerFromDateError:false,
      PrintStickerToDateError:false,
      todaysDate: '',
      validDateRange: '',
      validDateRangeFrom: '',
      todaysDate2: '',
      validDateRange2: '',
      validDateRangeFrom2: '',
      selectedFromDate:'',
      PincodeFromDate: null,
      PincodeToDate: null,
      TotalDataPincode: [],
      PincodeType: "Pickup",
      totalCountPincode: 0,
      totalPagePincode: 0,
      currentPincodePage: 1,
      companyNamelist: [],
      companyName: null,
      pincode: null,
      selectedpincodedate: null,
      selectedPincodeFromDate: '',
      pincodeTrack:false,
      pincodeErr:0,
      minfromdate:''
    }
  },
  computed: {
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment.utc(date).format('DD-MM-YYYY HH:mm:ss');
    },
  },
  async mounted() {
      var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
      this.hubId = userdetail.hubID[0];
      this.todaysDate1 = moment().format('YYYY-MM-DD');
      this.todaysDate2 = moment().format('YYYY-MM-DD');
      await this.pincodesearchFilter();
      this.getCompanyShortName();
  },
  methods: {
    isIntegerOnlty: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    onPageChangePincode(page)
    {
      this.currentPincodePage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getpincodesummarydata();
    },
    pincodesearchFilter(){
      this.currentPincodePage = 1;
      this.pincodeTrack=true;
      this.offset = 0;
      this.getpincodesummarydata();
    },
    async getCompanyShortName() {
      try {
        var CompanyShortList = [];
        let result = await TripServices.getActiveInactiveClientList()
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
        this.companyNamelist.push({
        'id': CompanyShortList[i].ClientMasterID,
        'label': CompanyShortList[i].ClientShortName,
        'CompanyName': CompanyShortList[i].CompanyName
        })
        }
      } catch (err) {
        console.log(err);
      }
    },
    pincoderesetSearch(){
      this.PincodeType="Pickup";
      this.pincodeTrack=false,
      this.idx=1;
      this.currentPincodePage = 1;
      this.PincodeFromDate=null;
      this.PincodeToDate=null;
      this.pincode=null;
      this.companyName=null;
      this.getpincodesummarydata();
      this.FromDateErr = '';
      this.ToDateErr = '';
      this.pincodeErr=0;
    },
    checkPincodeToDate() {
      this.PincodeToDate = null;
      this.todaysDate2 = moment().format('YYYY-MM-DD');
      this.selectedPincodeFromDate = moment.utc(this.PincodeFromDate).format("YYYY-MM-DD").valueOf();
      let result =  moment().diff(this.selectedPincodeFromDate, 'days')
      if(result>6){
        this.selectedpincodedate = moment(this.selectedPincodeFromDate).add(6, 'days').format('YYYY-MM-DD').valueOf();
      }else{
        this.selectedpincodedate = this.todaysDate2
      }
      if (this.selectedPincodeFromDate <= this.todaysDate2 && this.selectedPincodeFromDate <= this.selectedpincodedate) {
        this.validDateRange2 = this.selectedpincodedate
      } else {
        this.validDateRange2 = this.todaysDate2
      }
      if (this.PincodeFromDate != null) { this.PrintStickerFromDateError = false }
    },
    checkPincodeFromDate() {
      this.selectedpincodedate = moment(this.selectedPincodeFromDate).add(6, 'days').format('YYYY-MM-DD').valueOf();
      this.validDateRangeFrom2 = moment.utc(this.PincodeToDate).format("YYYY-MM-DD").valueOf();
      if (this.PincodeToDate > this.selectedpincodedate) {
        this.$alertify.error("Please select date range should be less than or equal to 7 Days")
        this.PincodeToDate = null;
      }
      if (this.PincodeToDate != null) { this.PrintStickerToDateError = false }
      if (this.PincodeToDate > this.todaysDate2) {
        this.$alertify.error("You can't select more than todays date")
        this.PincodeToDate = null;
      }
    },
    async checkPincodeErr() {
      if (this.pincode != null) {
        this.pincodeErr = (this.pincode.length < 6 && this.pincode.length > 0 ? 1 : 0)
      }
      return this.pincodeErr
    },
    async getpincodesummarydata(flag) {
      try {
        if (await this.checkPincodeErr() == 1) {
          this.pincodeTrack = false;
          return false
        }
        this.isLoading = true;
          let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
        }
        if (flag == 1) {
          inputPayload.limit = 30;
        }
        if (this.PincodeType) {
          inputPayload.businessservice = this.PincodeType
        }
        if (this.pincode && this.PincodeType == "Pickup") {
          inputPayload.pickuppincode = parseInt(this.pincode);
        }
        else if (this.pincode && this.PincodeType == "Delivery") {
          inputPayload.destinationpincode = parseInt(this.pincode);
        }
        if (this.PincodeFromDate != null) {
          inputPayload.createddatefrom = (this.PincodeFromDate);
        }
        if (this.PincodeToDate != null) {
          inputPayload.createddateto = (this.PincodeToDate);
        }
        if (this.companyName != null) {
          inputPayload.clientname = (this.companyName.label);
        }
        let result = await Report.getpincodelogs(inputPayload)
        if (result.data.code == 200 && result.data.data != null) {
          this.totalCountPincode = result.data.data.count;
          this.TotalDataPincode = result.data.data.data;
        }
        else {
          this.totalCountPincode = 0;
        }
        if (this.totalCountPincode < this.pageLimit) {
          this.totalPagePincode = 1
        } else {
          this.totalPagePincode = Math.ceil(this.totalCountPincode / this.pageLimit);
        }
        this.isLoading = false;
        return result;
      }
      catch (err) {
        this.isLoading = false;
      }
    },
    async exportPincodeData() {
      try {
        let inputPayload = {
          "offset": 0,
          "limit": this.totalCountPincode,
        }
        if (this.PincodeType) {
          inputPayload.businessservice = this.PincodeType
        }
        if (this.pincode && this.PincodeType == "Pickup") {
          inputPayload.pickuppincode = this.pincode;
        }
        else if (this.pincode && this.PincodeType == "Delivery") {
          inputPayload.destinationpincode = this.pincode;
        }
        if (this.Error) {
          inputPayload.error = this.Error;
        }
        if (this.PincodeFromDate != null) {
          inputPayload.createddatefrom = (this.PincodeFromDate);
        }
        if (this.PincodeToDate != null) {
          inputPayload.createddateto = (this.PincodeToDate);
        }
        if (this.companyName != null) {
          inputPayload.clientname = (this.companyName.label);
        }
        let data = await Report.getpincodelogs(inputPayload)
        this.isLoading = true;
        if (data && data.data.code == 200) {
          var tempdata = [];
          var temp = data.data.data.data;
          if (temp.length > 0) {
            temp.forEach(el => {
              tempdata.push({
                'Pincode': el.pincode,
                'Business Unit': el.businessunit,
                'Business Service': el.businessservice,
                'Client Name': el.clientname,
                'Physical Weight': el.physicalweight,
                'Logged In Hub Name': el.hubname,
                'Log Type': el.logtype,
                'Date': el.createddate,
              });
            });
          }
          else {
            this.$alert(data.data.message, "", "error");
          }
          let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
          const data1 = XLSX.utils.json_to_sheet(tempdata);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data1, 'data')
          XLSX.writeFile(wb, dt + '_pincodeLog.xlsx');
        }
        else {
          this.$alert(data.data.message, "", "error");
          this.$alert("No Pincode records to download", "Pincode Data", "error");
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/report/views/PrintingLog/pincodelog/pincodelog.component.js